// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chartkit-table-paginator {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 36px;
  padding-left: 5px;
  gap: 28px;
  background-color: var(--data-table-color-base);
  overflow: auto;
}
.chartkit-table-paginator__arrow-btn_reversed {
  transform: rotate(180deg);
}
.chartkit-table-paginator__range {
  font-style: italic;
  color: var(--g-color-text-secondary);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: 35px;
  padding-right: 1px;
}
.chartkit-table-paginator input::-webkit-outer-spin-button, .chartkit-table-paginator input::-webkit-inner-spin-button {
  /* stylelint-disable-next-line */
  -webkit-appearance: none;
  margin: 0;
}
.chartkit-table-paginator input[type=number] {
  /* stylelint-disable-next-line */
  -moz-appearance: textfield; /* Firefox */
}
.chartkit-table-paginator .chartkit-table-paginator__page-input {
  width: 60px;
  margin: 0 5px;
}`, "",{"version":3,"sources":["webpack://./src/ui/libs/DatalensChartkit/ChartKit/components/Widget/components/Table/Paginator/Paginator.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,8CAAA;EACA,cAAA;AACJ;AAEQ;EACI,yBAAA;AAAZ;AAII;EACI,kBAAA;EACA,oCAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAFR;AAOI;EAEI,gCAAA;EACA,wBAAA;EACA,SAAA;AANR;AASI;EACI,gCAAA;EACA,0BAAA,EAAA,YAAA;AAPR;AAYI;EACI,WAAA;EACA,aAAA;AAVR","sourcesContent":[".chartkit-table-paginator {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  min-height: 36px;\n  padding-left: 5px;\n  gap: 28px;\n  background-color: var(--data-table-color-base);\n  overflow: auto;\n}\n.chartkit-table-paginator__arrow-btn_reversed {\n  transform: rotate(180deg);\n}\n.chartkit-table-paginator__range {\n  font-style: italic;\n  color: var(--g-color-text-secondary);\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  line-height: 35px;\n  padding-right: 1px;\n}\n.chartkit-table-paginator input::-webkit-outer-spin-button, .chartkit-table-paginator input::-webkit-inner-spin-button {\n  /* stylelint-disable-next-line */\n  -webkit-appearance: none;\n  margin: 0;\n}\n.chartkit-table-paginator input[type=number] {\n  /* stylelint-disable-next-line */\n  -moz-appearance: textfield; /* Firefox */\n}\n.chartkit-table-paginator .chartkit-table-paginator__page-input {\n  width: 60px;\n  margin: 0 5px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
